import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React, { useEffect, useRef } from "react";

type Props = {
  chartSeries: any;
  onMouseEnter: (seriesIdx: number) => void;
  onMouseLeave: (seriesIdx: number) => void;
};

const useStyles = makeThemedStyles("Legend", (theme) => ({
  legend: {
    height: "30px",
    backgroundColor: "#fafafa",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontWeight: 500,
    fontSize: "13px",
    padding: "10px",
    color: "rgba(0, 0, 0, 0.87)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(38, 166, 242, 0.05)",
    },
  },
  container: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  dot: {
    height: "7px",
    width: "7px",
    borderRadius: "50%",
    backgroundColor: "var(--dotColor)",
  },
}));

const Legend = (props: Props) => {
  const styles = useStyles();
  const { chartSeries, onMouseEnter, onMouseLeave } = props;

  return (
    <div className={styles.container}>
      {chartSeries?.map((ser: any, i: number) => (
        <div
          className={styles.legend}
          style={{ "--dotColor": ser.color } as React.CSSProperties}
          onMouseEnter={() => onMouseEnter(i)}
          onMouseLeave={() => onMouseLeave(i)}
        >
          <div className={styles.dot} />
          <div>{ser.name}</div>
        </div>
      ))}
    </div>
  );
};

export default Legend;
